import { ChannelAddAdmin, ChannelAddAdminResponse } from "../proto/ChannelAddAdmin_pb";
import { GroupAddAdmin, GroupAddAdminResponse } from "../proto/GroupAddAdmin_pb";
import store from "../store";
import { addAdmin, editRoom } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";
import { getStorage } from "../libs/storage";
import { STORAGE_USER_ID } from "../constants/localstorage";
import { GroupRoom } from "../proto/Global_pb";

export default class HandleRoomAddAdminResponse extends BaseHandler<GroupAddAdminResponse | ChannelAddAdminResponse, GroupAddAdmin | ChannelAddAdmin> {
  handle() {
    const addAdminResponse = this.response.toObject();
    const isMine = addAdminResponse.memberId === getStorage(STORAGE_USER_ID);
    const room = store.getState().rooms.rooms[addAdminResponse.roomId];
    console.log("[ADD_ADMIN] in HandleRoomAddAdminResponse ", addAdminResponse);
    console.log("[ADD_ADMIN] isMine ", isMine);
    // if (isMine)
    // store.dispatch(
    //   editRoom({
    //     roomId: addAdminResponse.roomId,
    //     room: {
    //       //@ts-ignore
    //       permission: {
    //         ...room.permission,
    //         ...addAdminResponse.permission,
    //       },
    //       //  @ts-ignore
    //       groupRoomExtra: {
    //         ...room.groupRoomExtra,
    //         role: GroupRoom.Role.ADMIN,
    //       },
    //     },
    //   })
    // );
    store.dispatch(
      addAdmin({
        roomId: addAdminResponse.roomId,
        memberId: addAdminResponse.memberId,
        adminrights: addAdminResponse.permission!,
        permission: addAdminResponse.permission,
        isMine: isMine,
      })
    );
  }
}
